import React, { createContext, useState, useContext, useEffect } from 'react';
import { login as loginService, logout as logoutService } from '../services/authService';
import * as authService from '../services/authService';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const [loading, setLoading] = useState(false);

  const login = async (email, password) => {
    try {
      const result = await authService.login(email, password);
      if (result.success && result.user) {
        setUser(result.user);
        localStorage.setItem('user', JSON.stringify(result.user));
        return { success: true, user: result.user };
      } else {
        return { success: false, message: result.message || 'Invalid credentials' };
      }
    } catch (error) {
      console.error('login error:', error);
      return { success: false, message: 'An error ocurred during login ' };
    }
  };

  const logout = async () => {
    try {
      await logoutService();
      setUser(null);
      localStorage.removeItem('user');
    } catch (error) {
      console.error('Logout error:', error);
      setUser(null);
      localStorage.removeItem('user');
    }
  };

  // Verificar si el usuario es admin
  const isAdmin = () => {
    return user?.role === 'admin';
  };

  // Verificar si el usuario es empleado
  const isEmployee = () => {
    return user?.role === 'employee';
  };

  // ── NUEVO: Verificar si el usuario es de cocina ──
  const isKitchen = () => {
    return user?.role === 'kitchen';
  };

  // Verificar si el usuario está autenticado
  const isAuthenticated = () => {
    return user !== null;
  };

  return (
    <AuthContext.Provider
      value={{ user, loading, login, logout, isAdmin, isEmployee, isKitchen, isAuthenticated }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};